import {
  type APITriplet,
  type ModelTriplet,
  RDK_MODEL_NAME_FAKE,
} from '$lib/resource-type';

import { isBuiltinAPI } from './api-types';
import { isBuiltinModel } from './models';
import { ServiceSubtypes } from './services';

export const isCartographerSLAMService = (
  api: APITriplet,
  model: ModelTriplet
) =>
  isBuiltinAPI(api, ServiceSubtypes.SLAM) &&
  (isCartographerModel(model) || isBuiltinModel(model, RDK_MODEL_NAME_FAKE));

const isCartographerModel = (model: ModelTriplet) =>
  model.namespace === 'viam' &&
  model.family === 'slam' &&
  model.name === 'cartographer';
